// src/belediye/pages/YetkisizPage.js
//
// FAZ-12 — 403 / yetkisiz erişim sayfası. Mobil öncelikli: tek kolon,
// büyük dokunma hedefleri. Route kaydı FAZ-13'te yapılır; bu fazda sayfa
// yalnız hazırlanır (PermissionGate /yonetim/yetkisiz'e yönlendirecek).

import { useNavigate } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/24/outline";

import "./YetkisizPage.css";

export default function YetkisizPage() {
  const navigate = useNavigate();

  return (
    <div className="yetkisiz-page">
      <div className="yetkisiz-card">
        <div className="yetkisiz-icon-wrap">
          <LockClosedIcon className="yetkisiz-icon" />
        </div>

        <h1 className="yetkisiz-title">Bu sayfaya erişim yetkiniz yok</h1>
        <p className="yetkisiz-text">
          Bu içerik, hesabınıza tanımlı izinlerin dışında. Yanlış olduğunu
          düşünüyorsanız birim yöneticinizle iletişime geçebilirsiniz.
        </p>

        <div className="yetkisiz-actions">
          <button
            type="button"
            className="yetkisiz-btn yetkisiz-btn-primary"
            onClick={() => navigate("/yonetim")}
          >
            Panele dön
          </button>
          <button
            type="button"
            className="yetkisiz-btn yetkisiz-btn-secondary"
            onClick={() => navigate("/yonetim/birim-sec")}
          >
            Birim değiştir
          </button>
        </div>
      </div>
    </div>
  );
}
